// The landing page (dialup.lv) and the app (app.dialup.lv) are separate
// origins, so the landing page cannot read the Supabase session out of the
// app's localStorage. This cookie is a non-sensitive hint — no token, no user
// id, just "someone is signed in here" — scoped to the registrable domain so
// the landing page can point its CTA at the app instead of the login screen.
// A stale hint is harmless: /login redirects signed-in users to /home and
// signed-out ones get the login form they would have got anyway.

const COOKIE_NAME = 'dialup_session';
const MAX_AGE_SECONDS = 30 * 24 * 60 * 60;

// Good enough for dialup.lv and its subdomains; multi-part public suffixes
// (example.co.uk) would need the full PSL, which we do not serve from.
const getCookieDomain = (): string | null => {
  const { hostname } = window.location;
  if (/^[\d.]+$/.test(hostname)) return null;

  const labels = hostname.split('.');
  if (labels.length < 2) return null;

  return `.${labels.slice(-2).join('.')}`;
};

const writeCookie = (value: string, maxAgeSeconds: number): void => {
  if (typeof document === 'undefined') return;

  const parts = [
    `${COOKIE_NAME}=${value}`,
    'Path=/',
    `Max-Age=${maxAgeSeconds}`,
    'SameSite=Lax',
  ];

  const domain = getCookieDomain();
  if (domain) parts.push(`Domain=${domain}`);
  if (window.location.protocol === 'https:') parts.push('Secure');

  document.cookie = parts.join('; ');
};

export const setAppSessionHint = (): void => writeCookie('1', MAX_AGE_SECONDS);

// Same Path/Domain as the write, otherwise the browser keeps the original.
export const clearAppSessionHint = (): void => writeCookie('', 0);
